export enum UserPermissionsEnum {
  ADMIN = 'admin',
  READ = 'read',
  WRITE = 'write',
}
